// extracted by mini-css-extract-plugin
export var text = "_3e-0";